module.exports = __webpack_public_path__ + "img/logo.aad85f32.svg";